var _circle, _path, _circle2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconReservePrice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.2,
    fill: "#FFE196",
    stroke: "#F8B407",
    strokeWidth: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.74815 12V3H7.35556V12H6.74815ZM8.35926 5.9707C8.32963 5.68711 8.20247 5.4668 7.97778 5.30977C7.75309 5.15273 7.44815 5.07422 7.06296 5.07422C6.80123 5.07422 6.58025 5.10938 6.4 5.17969C6.21975 5.24766 6.08148 5.34258 5.98519 5.46445C5.89136 5.58633 5.84444 5.72461 5.84444 5.8793C5.83951 6.0082 5.8679 6.1207 5.92963 6.2168C5.99383 6.31289 6.08148 6.39609 6.19259 6.46641C6.3037 6.53437 6.4321 6.59414 6.57778 6.6457C6.72346 6.69492 6.87901 6.73711 7.04444 6.77227L7.72593 6.92695C8.05679 6.99727 8.36049 7.09102 8.63704 7.2082C8.91358 7.32539 9.15309 7.46953 9.35556 7.64062C9.55802 7.81172 9.71482 8.01328 9.82593 8.24531C9.93951 8.47734 9.99753 8.74336 10 9.04336C9.99753 9.48398 9.87901 9.86602 9.64444 10.1895C9.41235 10.5105 9.07654 10.7602 8.63704 10.9383C8.2 11.1141 7.67284 11.202 7.05556 11.202C6.44321 11.202 5.90988 11.1129 5.45556 10.9348C5.0037 10.7566 4.65062 10.493 4.3963 10.1437C4.14444 9.79219 4.01235 9.35742 4 8.83945H5.55185C5.56914 9.08086 5.64198 9.28242 5.77037 9.44414C5.90123 9.60352 6.07531 9.72422 6.29259 9.80625C6.51235 9.88594 6.76049 9.92578 7.03704 9.92578C7.30864 9.92578 7.54444 9.88828 7.74444 9.81328C7.94691 9.73828 8.1037 9.63398 8.21481 9.50039C8.32593 9.3668 8.38148 9.21328 8.38148 9.03984C8.38148 8.87812 8.33086 8.74219 8.22963 8.63203C8.13086 8.52187 7.98519 8.42812 7.79259 8.35078C7.60247 8.27344 7.36914 8.20312 7.09259 8.13984L6.26667 7.94297C5.62716 7.79531 5.12222 7.56445 4.75185 7.25039C4.38148 6.93633 4.19753 6.51328 4.2 5.98125C4.19753 5.54531 4.31975 5.16445 4.56667 4.83867C4.81605 4.51289 5.15802 4.25859 5.59259 4.07578C6.02716 3.89297 6.52099 3.80156 7.07407 3.80156C7.63704 3.80156 8.1284 3.89297 8.54815 4.07578C8.97037 4.25859 9.29877 4.51289 9.53333 4.83867C9.7679 5.16445 9.88889 5.5418 9.8963 5.9707H8.35926Z",
    fill: "#74570B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 3.5,
    fill: "#F8B407"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2637 9.48895L11.2637 12.1287L13.0354 12.1288",
    stroke: "white",
    strokeWidth: 0.798,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReservePrice);
export default __webpack_public_path__ + "static/media/icon-reserve-price.c8a36480d75fc6b8a895a95cdc2d8730.svg";
export { ForwardRef as ReactComponent };